import React, { useEffect } from "react";
import { Button } from "../components/button/button";
import Chip from "../components/chip/chip";
import { Header } from "../components/header/header";
import { Search } from "../components/search/search";
import approve from "../img/approve.svg";
import check from "../img/check.svg";
import disapprove from "../img/disapprove.svg";
import edit from "../img/edit.svg";
import table from "../img/table.svg";
import Complete from "../img/Complete.svg";
import xerror from "../img/xerror.svg";
import "../styles/control.css";
import axiosInstance from "../auth/axiosInstance";
import FooterStatus from "../components/footerStatus/footerStatus";
import ModalEdit from "../components/modalEdit/modalEdit";
import { Input } from "../components/input/input";
import Filter from "../components/filter/filter";
import ModalCount from "../components/modalCount";
import ModalSucesso from "../components/ModalSucesso";
import { ReactComponent as Alert } from "../img/Icon awesome-exclamation-circle.svg";
import ModalConfirm from "../components/ModalConfirm/ModalConfirm";
import { useStore } from "../store/useStore";
import { useMsal } from "@azure/msal-react";

function Control() {
  let items = [
    {
      title: "Control",
      img: table,
      route: 0
    },
    {
      title: "Approved",
      img: check,
      route: 1
    },
    {
      title: "Disapprovals",
      img: xerror,
      route: 2
    },
  ];

  const [actualActive, setActualActive] = React.useState(0);
  const [showFeedback, setShowFeedback] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(false);
  const [arrToCheckbox, setArrToCheckbox] = React.useState([])
  const [modalComentario, setModalComentario] = React.useState(false);
  const [comentario, setComentario] = React.useState("");
  const [countSelected, setCountSelected] = React.useState({});
  const [showModalCount, setShowModalCount] = React.useState(false);
  const [actionType, setActionType] = React.useState(false);
  const [status, setStatus] = React.useState(false);
  const [content, setContent] = React.useState("");
  const [countId, setCountId] = React.useState({ id: 0 });
  const [openModalRemoveClient, setOpenModalRemoveClient] = React.useState(false);
  const { countData, fetchData } = useStore()
  const [initialData, setInitialData] = React.useState(countData)
  const [localVar, setLocalVar] = React.useState(countData);

  useEffect(() => {
    const newArray = countData.map((data) => ({
      ...data,
      clientName: data.client.client
    }));
  
    setInitialData(newArray);
    setLocalVar(newArray);
  }, [countData]);

  const { accounts } = useMsal()

  function postLog(text) {
    axiosInstance.post('logs', {
      email: accounts[0].username,
      name: accounts[0].name,
      action: text
    })
      .catch(err => console.log(err))
  }

  function approveOrDisapproveDc(e, status, id) {
    e.preventDefault();
    if (status === 0) {
      setModalComentario(true);
      setShowModalCount(false);
    } else if (status === 1 || status === 2) {
      let obj = { room_id: countId.room_id, status: status, comment: comentario, reproved: arrToCheckbox }
      axiosInstance
        .patch(`count/${id}`, obj)
        .then((res) => {
          if (res.status === 200) {
            postLog(`Count to ${countSelected.room.site.site} and ${countSelected.room.room} ${status === 1 ? 'Approved' : 'Rejected'}`)
            if (status === 0) {
              setShowFeedback(false);
            } else {
              setTimeout(() => {
                setShowFeedback(false);
                setContent("Status successfully updated.");
              }, 10000);
              setShowModalCount(false);
              setShowFeedback(true);
              setModalComentario(false);
              setComentario("");
            }
            setShowEdit(false)
            fetchData('count', 'countData');
          }
        })
        .catch((err) => {
          setContent("Error on updating status");
          setStatus(true);
        });
    }
  }

  function delClient() {
    axiosInstance
      .delete(`count/${countId.id}`)
      .then((res) => {
        if (res.status === 200) {
          postLog(`Count to ${countSelected.room.site.site} | ${countSelected.room.room} deleted`)
          fetchData('count', 'countData');
          setContent("Count deleted successfully.");
          setStatus(true);
          openModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setContent("Error on deleting count.");
        setStatus(true);
      });
  }

  React.useEffect(() => {
    if (Object.keys(countSelected).length > 0) {
      setShowModalCount(true);
    }
  }, [countSelected]);

  function onChange(event) {
    setComentario(event.target.value);
  }

  function openModal(status) {
    setOpenModalRemoveClient(status);
  }

  return (
    <section className="control-body">
      <Header line>
        <Chip
          onClick={setActualActive}
          items={items}
          quantity={3}
          active={actualActive}
          style={{ width: "675px" }}
        />
      </Header>
      <div className="search-area">
        <Search
          initialData={initialData}
          set={setLocalVar}
          style={{
            border: "1px solid #0F0742",
            boxShadow: "0 0 0",
            width: "100%",
          }}
          placeholder="Search by client, data center or data hall names"
        />
      </div>
      <h1 className="title-totalracks">
        {actualActive === 0
          ? "Total Count"
          : actualActive === 1
            ? "Approved Counts"
            : "Disapproved Counts"}
        ({localVar.filter((el) => el.status === actualActive).length})
      </h1>
      <section className="table-estructure-rack">
        {
          localVar.filter((el) => el.status === actualActive).length === 0
            ? <div className="complete-count">
              <h1>You Completed the Rack Counting</h1>
              <img src={Complete} alt="table" />
            </div>
            : (localVar.map((value) => {
              if (actualActive === value.status) {
                return (
                  <div className="row-table-estructure">
                    <div className="column-table-estructure">
                      <h1>Data Center</h1>
                      <h3>{value.room.site.site}</h3>
                    </div>
                    <div className="column-table-estructure">
                      <h1>Data Hall</h1>
                      <h3>{value.room.room}</h3>
                    </div>
                    <div className="column-table-estructure" style={{width:"200px"}}>
                      <h1>Client</h1>
                      <h3>{value.client.client}</h3>
                    </div>
                    <div className="column-table-estructure">
                      <h1>Cage</h1>
                      <h3>{!!value.cage ? value.cage : "No Cage"}</h3>
                    </div>
                    <div className="column-table-estructure">
                      <h1>Date</h1>
                      <h3>{new Date(value.createdAt).toLocaleDateString()}</h3>
                    </div>
                    <div className="column-table-estructure">
                      <h1>Added</h1>
                      <h3>{value.added}</h3>
                    </div>
                    <div className="column-table-estructure">
                      <h1>Churned</h1>
                      <h3>{value.churned}</h3>
                    </div>
                    {value.status === 0 ? (
                      <div className="validate-section">
                        <img
                          onClick={
                            () => {
                              setCountSelected(value);
                              setCountId(value);
                              return setActionType(true);
                            }
                          }
                          src={approve}
                          alt="check button"
                        />
                        <img
                          onClick={
                            () => {
                              setCountSelected(value);
                              setCountId(value);
                              return setActionType(false);
                            }
                          }
                          src={disapprove}
                          alt="check button"
                        />
                      </div>
                    ) : (
                      <div
                        className={`status-validate-section ${actualActive === 1
                          ? "status-approved-validate"
                          : "status-disapproved-validate"
                          }`}
                      >
                        <div>
                          {actualActive === 1 ? "Approved" : "Disapproved"}
                        </div>
                        {
                          actualActive == 1 || actualActive == 2 ?
                          <></> :
                          <img
                            onClick={() => {
                              setShowEdit(true); return setCountId(value)
                            }}
                            src={edit}
                            alt="edit"
                          />
                        }
                        
                      </div>
                    )}
                  </div>
                );
              } else {
                return null;
              }
            })
            )}
      </section>
      <ModalEdit
        show={showEdit}
        deletar={() => {
          openModal(true);
        }}
        close={() => setShowEdit(false)}
        label={`Do you wish to ${actualActive === 2 ? "Approved" : "Disapproved"
          } this ${actualActive === 1 ? "Approved" : "Disapproved"} count?`}
        title="Edit Count"
        color={actualActive === 2 ? "#59975C" : "#B73D3D"}
        labelButton={actualActive === 2 ? "Approve" : "Disapprove"}
        function={
          actualActive === 2
            ? (e) => approveOrDisapproveDc(e, 1, countId.id)
            : (e) => approveOrDisapproveDc(e, 2, countId.id)
        }
      >
        {localVar.map((value) => {
          if (countId.id === value.id) {
            return (
              <div className="content-edit-control">
                <table>
                  <thead>
                    <tr>
                      <th>Room</th>
                      <th>Date</th>
                      <th>Added</th>
                      <th>Churned</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{value.room.room}</td>
                      <td>{new Date(value.createdAt).toLocaleDateString()}</td>
                      <td>{value.added}</td>
                      <td>{value.churned}</td>
                    </tr>
                  </tbody>
                </table>
                {actualActive === 1 ? (
                  <Input
                    tag="textarea"
                    required
                    title="Justify why you want to disapprove."
                    onChange={onChange}
                  />
                ) : (
                  <></>
                )}
              </div>
            );
          }
        })}
      </ModalEdit>
      <FooterStatus
        show={showFeedback}
        cancel={() => setShowFeedback(false)}
        text={`Rack Count successfully updated, you can see it in the respective area.`}
      />

      <ModalCount
        type={actionType}
        show={showModalCount}
        setArrToCheckbox={setArrToCheckbox}
        data={countSelected}
        cancel={() => { setShowModalCount(false); setCountSelected({}); setCountId({ id: 0 }); return setModalComentario(false) }}
        enviar={(e) =>
          actionType
            ? approveOrDisapproveDc(e, 1, countSelected.id)
            : approveOrDisapproveDc(e, 0, countSelected.id)
        }
        rejeitar={(e) => approveOrDisapproveDc(e, 2, countSelected.id)}
        onChange={onChange}
      />
      <div
        className="modal_content-count"
        style={modalComentario ? { display: "flex" } : { display: "none" }}
      >
        <Alert />
        <p className="modal_p-count">Insert reason for churned:</p>

        <textarea
          className="modal_textarea-count"
          placeholder="Insert reason for churned"
          onChange={onChange}
        ></textarea>
        <div>
          <button
            className="modal_button-count-no"
            onClick={() => { setModalComentario(false); return setComentario("") }}
          >
            CANCEL
          </button>
          <button
            className="modal_button-count"
            onClick={(e) => {
              approveOrDisapproveDc(e, 2, countSelected.id[0]);
            }}
          >
            SUBMIT
          </button>
        </div>
      </div>
      <ModalSucesso
        status={status}
        content={content}
        ok={() => setStatus(false)}
      />

      <div
        style={
          openModalRemoveClient ? { display: "flex" } : { display: "none" }
        }
      >
        <ModalConfirm
          yes={() => delClient()}
          no={() => openModal(false)}
          content={"Are you sure you want to delete this count?"}
        />
      </div>
    </section >
  );
}

export default Control;
